import { ApiCitation, ApiRetrievedReference } from "@/types/questionnaire/api"

/**
 * Transform snake_case citation response from API to camelCase for frontend use.
 *
 * Kept as its own pure module (no Amplify/fetch imports) so it can be shared by
 * assistantChatService (heavy, has auth/fetch deps) and parseAgentAction (small,
 * pure) without creating an import cycle between the two.
 */
export function transformCitationsFromApi(
  rawCitations: unknown[],
): ApiCitation[] {
  return rawCitations.map((citation: unknown) => {
    const c = citation as {
      generated_response_part?: string | null
      generatedResponsePart?: string | null
      retrieved_references?: Array<{
        content?: string
        location?: {
          s3Location?: { uri: string }
          type?: string
          url?: string
        }
        metadata?: Record<string, unknown>
        origin?: "rag" | "web" | "mc-data" | "help"
      }>
      retrievedReferences?: Array<{
        content?: string
        location?: {
          s3Location?: { uri: string }
          type?: string
          url?: string
        }
        metadata?: Record<string, unknown>
        origin?: "rag" | "web" | "mc-data" | "help"
      }>
    }
    const references = c.retrieved_references || c.retrievedReferences || []
    return {
      generatedResponsePart:
        c.generated_response_part ?? c.generatedResponsePart ?? null,
      retrievedReferences: references.map(
        (ref): ApiRetrievedReference => ({
          content: ref.content,
          location: {
            s3Location: ref.location?.s3Location,
            type: ref.location?.type,
            url: ref.location?.url,
          },
          metadata: ref.metadata as ApiRetrievedReference["metadata"],
          origin: ref.origin,
        }),
      ),
    }
  })
}
